export const showError = (error) => {
  console.log(error)
}

export const showMessage = (message) => {
  console.log(message)
}

export const showWarning = (warning) => {
  console.log(warning)
}
